import { BaseModel } from 'src/app/shared/models/base.model';

export class News extends BaseModel{
    
    public picture:any;
    public club:any;
    public userName:any;
    public createdAt:any;
    public title:any;
    public photo:any;
    public description:any;
    public comments:any;
    public user:any;

    static fromJsonToObject(jsonData:any):News{
        return Object.assign(new News(),jsonData);
    }
}